import { fetchData } from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";

export interface Form30UserPreferences {
    _id: string;
    user_id: string;
    year: number;
    table_id: string;
    row_id: string;
    column_key: string;
    createdAt: string;
    updatedAt: string;
}

export interface Form30UserPreferencesResponse {
    success: boolean;
    data: Form30UserPreferences | null;
    message?: string;
    error?: string;
}

export interface SaveForm30UserPreferencesRequest {
    year: number;
    table_id: string;
    row_id: string;
    column_key: string;
}

/**
 * Получить сохраненные предпочтения пользователя
 */
export const getUserPreferences = async (): Promise<Form30UserPreferencesResponse> => {
    const url = `/form30-preferences`;
    
    const response = await fetchData(url, {
        method: "GET",
        headers: {
            Authorization: authToken(),
            "Content-Type": "application/json",
        }
    }, 2);

    return response.json();
};

/**
 * Сохранить предпочтения пользователя
 */
export const saveUserPreferences = async (
    data: SaveForm30UserPreferencesRequest
): Promise<Form30UserPreferencesResponse> => {
    const response = await fetchData('/form30-preferences', {
        method: "POST",
        headers: {
            Authorization: authToken(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
    }, 2);

    return response.json();
};
